<template>
  <div class="foot">
    <div class="footer common_backgroundImg">
      <div class="common_content" v-if="content">
        <div :class="['footer_content',(flag?'common_display_center':'')]">
          <div class="footer_content_left">
            <div class="contact_us">
              <span :class="['contact_us_img common_backgroundImg',(flag?'':'footer_auto')]">
                <h2 class="contact_us_des">联系我们</h2>
              </span>
            </div>
            <div class="contact_des" style="text-align:center">
              <span>{{data.name}}</span>
            </div>
          </div>
          <div class="footer_content_line"></div>
          <div :class="['footer_content_right',(flag?'common_display':'')]">
            <div
              :class="flag?'footer_right':'footer_auto'"
              v-for="(item,index) in lists"
              :key="index"
            >
              <div class="footer_right_img common_backgroundImg">
                <img :src="imgPath+item.file_path" />
              </div>
              <p class="footer_right_des">
                <span>{{item.service_account_name}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="common_content">
        <p>
          <span>版权所有</span>
        </p>
        <p>鲁公网安备 37020202001092 号</p>
      </div>
    </div>
  </div>
</template>

<script>
import { GetContactUsList } from "@/api/admin/common.js";
import { mapGetters } from "vuex";
export default {
  props: {
    content: Boolean
  },
  data() {
    return {
      data: [],
      flag: true,
      timer: true,
      imgPath: window.apiObj.apiUrl,
      lists: []
    };
  },
  computed: {
    ...mapGetters(["screenWidth"])
  },
  watch: {
    screenWidth(val) {
      this.footControl(val);
    }
  },
  created() {
    this.footControl(this.screenWidth);
    this.getList();
  },

  methods: {
    footControl(val) {
      if (val < 768) {
        this.flag = false;
      } else {
        this.flag = true;
      }
    },
    getList() {
      // 联系我们
      GetContactUsList({}).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.lists = [
            {
              file_path: list.items.file_path1,
              service_account_name: list.items.service_account1_name
            },
            {
              file_path: list.items.file_path2,
              service_account_name: list.items.service_account2_name
            },
            {
              file_path: list.items.file_path3,
              service_account_name: list.items.service_account3_name
            }
          ];
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.foot {
  .footer {
    width: 100%;
    background-image: url(/image/index/background.png);
    .footer_content {
      padding: 50px 0px;
      .footer_content_left {
        .contact_us {
          margin: 20px 0 10px 0;
          .contact_us_img {
            position: relative;
            display: block;
            width: 200px;
            height: 90px;
            background-image: url(/image/index/contactUs.png);
            .contact_us_des {
              position: relative;
              top: 31%;
              left: 12%;
              color: #ffffff;
            }
          }
        }
      }
      .footer_content_line {
        width: 2px;
        background-color: #c4c4c4;
        margin: 0px 20px;
      }
      .footer_content_right {
        .footer_right {
          width: 150px;
          margin-left: 20px;
        }
        .footer_right_img {
          width: 150px;
          height: 150px;
          margin: 0 auto;
          img {
            width: 100%;
          }
        }
        .footer_right_des {
          text-align: center;
          word-break: break-all;
          font-size: 16px;
          line-height: 28px;
        }
      }
    }
  }
  .footer_bottom {
    text-align: center;
    font-size: 16px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.7);
  }
  .footer_auto {
    width: 150px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1000px) {
  .foot {
    .footer_bottom {
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 767px) {
  .foot {
    .footer {
      .footer_content {
        padding: 26px 0px 36px 0px;
        .footer_content_right {
          display: flex;
          .footer_auto {
            width: 0;
            flex: 1;
            .footer_right_img {
              width: 100%;
              height: 83px;
              text-align: center;
              img {
                width: 72%;
              }
            }
            .footer_right_des {
              font-size: 14px;
              margin-top: 5px;
            }
          }
        }
      }
      .contact_us {
        display: none;
        margin-right: 0px !important;
      }
      .contact_des {
        display: none;
      }
    }
    .footer_bottom {
      padding: 8px;
    }
  }
}
</style>
